import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import { appUrl } from "../../../constants/url-constants";
import BecomeOurPartnerInfo  from "../../../components/desktop/become-our-partner-info";
import { Helmet } from "react-helmet-async";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";
const metaTitle = "Register today to transform the Used Car Industry!";
const metaDescription = "Boost your business with Cars24's partner program! Get access to a wide range of verified used cars, transparent bidding process, paperwork support, and more.";

const BecomeOurPartner = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <link href={`${appUrl()}/become-our-partner/`} rel="canonical" />
            </Helmet>
            <ErrorHandler>
                <BecomeOurPartnerInfo />
            </ErrorHandler>
        </React.Fragment>
    );
};
export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withLayout(BecomeOurPartner));
